/**
 * Toolbar for stock planning sub-tabs.
 *
 * Provides a part search input and a page-size dropdown. Each sub-tab
 * owns the state (search text + page size) and passes the props in.
 */
import { Search } from 'lucide-react';
import { Input } from '../../ui/input';

const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  pageSize: number;
  onPageSizeChange: (value: number) => void;
  placeholder?: string;
}

export default function SubTabToolbar({
  search,
  onSearchChange,
  pageSize,
  onPageSizeChange,
  placeholder = 'Search by part number…',
}: Props) {
  return (
    <div className="flex items-center gap-3 mb-3">
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className="pl-9 h-8 text-sm"
        />
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <span className="text-xs text-muted-foreground">Rows:</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="h-8 text-sm border border-border rounded-md px-2 bg-background focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {PAGE_SIZE_OPTIONS.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
